/* 1012 Track / Shopify storefront bridge v2. No credentials or collector required. */
(function () {
  'use strict';
  var script = document.currentScript;
  if (!script || window.track1012CheckoutBridge) return;
  var store = script.dataset.store, project = script.dataset.project;
  if (!/^[a-z0-9-]{1,60}$/.test(store) || !/^[a-z0-9]{5,30}$/.test(project)) return;
  var KEY = '__1012_clarity', STORAGE = '1012-clarity-' + store;
  var active = false, session = null, identified = '', lastValue, queue = Promise.resolve();
  var pending = 0, bypass = new WeakSet(), consentKnown = false;
  var native = null, observing = false, waiting = [];
  script.dataset.version = '2';
  function status(value) {
    script.dataset.status = value;
    script.dataset.reference = active && session ? session.r : '';
    script.dataset.clarityUser = active && native ? native.u : '';
    script.dataset.claritySession = active && native ? native.s : '';
    script.dataset.playback = active && native ? String(native.b) : '';
  }
  function consent() {
    try {
      var cp = window.Shopify.customerPrivacy;
      return !!(cp && cp.analyticsProcessingAllowed() === true && cp.currentVisitorConsent().analytics === 'yes');
    } catch (_) { return false; }
  }
  function clarityAllowed() {
    // Reuse only the configured tag; never create a second tag or read Clarity cookies.
    return typeof window.clarity === 'function' && Array.from(document.scripts).some(function (s) {
      try { var u = new URL(s.src); return u.hostname === 'www.clarity.ms' && u.pathname === '/tag/' + project; }
      catch (_) { return false; }
    });
  }
  function storageRemove() { try { sessionStorage.removeItem(STORAGE); } catch (_) {} }
  function marker() {
    var value = { v: 1, p: project, r: session.r, t: Math.floor(Date.now() / 1000) };
    if (native && native.r === session.r) { value.v = 2; value.u = native.u; value.s = native.s; value.b = native.b; }
    return JSON.stringify(value);
  }
  function metadata(data, playback, info) {
    if (!active || !session || !consent() || !data || data.projectId !== project ||
      !info || info.analytics_Storage !== 'granted' || typeof data.userId !== 'string' || typeof data.sessionId !== 'string' ||
      !/^[a-z0-9]{1,30}$/.test(data.userId) || !/^[a-z0-9]{1,30}$/.test(data.sessionId)) return;
    var next = { r: session.r, u: data.userId, s: data.sessionId, b: playback === true ? 1 : 0 };
    if (!native || JSON.stringify(next) !== JSON.stringify(native)) {
      native = next;
      var value = marker(); cartForms(value); status('native-captured'); write(value);
    }
    waiting.splice(0).forEach(function (resolve) { resolve(); });
  }
  function observeNative() {
    if (observing) return;
    observing = true;
    // SDK callback, not cookie parsing. Recall also covers native session/consent restarts.
    window.clarity('metadata', metadata, false, true, true);
  }
  function touch() {
    var now = Date.now(), saved;
    if (!session) {
      try { saved = JSON.parse(sessionStorage.getItem(STORAGE)); } catch (_) {}
      if (saved && /^c1012:[a-z0-9-]+:[0-9a-f-]{36}$/.test(saved.r) && saved.r.indexOf('c1012:' + store + ':') === 0 &&
        Number.isSafeInteger(saved.at) && now >= saved.at && now - saved.at < 1800000) session = saved;
    }
    if (!session || now - session.at >= 1800000) {
      session = { r: 'c1012:' + store + ':' + crypto.randomUUID(), at: now };
      native = null;
    }
    session.at = now;
    try { sessionStorage.setItem(STORAGE, JSON.stringify(session)); } catch (_) {}
    if (identified !== session.r) {
      window.clarity('consentv2', { analytics_Storage: 'granted', ad_Storage: 'denied' });
      window.clarity('identify', session.r, session.r);
      window.clarity('set', 'track1012_session', session.r);
      identified = session.r;
    }
    observeNative();
    return marker();
  }
  function cartRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof root === 'string' && /^\/(?!\/)[a-zA-Z0-9/-]*$/.test(root) ? root.replace(/\/?$/, '/') : '/';
  }
  function write(value) {
    if (lastValue === value && !pending) return queue;
    pending++;
    queue = queue.catch(function () {}).then(async function () {
      // Consent could have changed while a previous cart write was in flight.
      if (value && !consent()) value = '';
      var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 2500);
      try {
        var attributes = {}; attributes[KEY] = value;
        var response = await fetch(cartRoot() + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin', keepalive: true, signal: controller.signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
        if (!response.ok) throw new Error('cart_write');
        lastValue = value;
        status(value && active ? 'cart-saved' : 'cleared');
      } catch (_) { lastValue = undefined; status('cart-error'); }
      finally { clearTimeout(timer); pending--; }
    });
    return queue;
  }
  function hidden(form, value) {
    var input = form.querySelector('input[data-1012-clarity]');
    if (!input) {
      input = document.createElement('input'); input.type = 'hidden'; input.name = 'attributes[' + KEY + ']';
      input.setAttribute('data-1012-clarity', ''); form.appendChild(input);
    }
    input.value = value;
  }
  function cartForms(value) {
    document.querySelectorAll('form[action]').forEach(function (form) {
      try { if (/\/cart\/?$/.test(new URL(form.action, location.href).pathname)) hidden(form, value); } catch (_) {}
    });
  }
  function reconcile() {
    var ok = consent(), was = active;
    active = ok && clarityAllowed();
    if (!active) {
      session = null; native = null; identified = ''; storageRemove(); cartForms('');
      if (was && typeof window.clarity === 'function') window.clarity('consentv2', { analytics_Storage: 'denied', ad_Storage: 'denied' });
      status(ok ? 'waiting-clarity' : 'no-consent');
      // Remove stale markers without accessing or sending any visitor identifier.
      if (consentKnown) return write('');
      return Promise.resolve();
    }
    try { var value = touch(); cartForms(value); status('ready'); return write(value); }
    catch (_) { active = false; session = null; cartForms(''); status('unavailable'); return write(''); }
  }
  window.track1012CheckoutBridge = { refresh: reconcile };
  function beforeCheckout() {
    // Checkout must remain usable even if several cart operations or the network stall.
    var saved = reconcile();
    if (!active) return saved;
    window.clarity('upgrade', 'track1012_checkout');
    window.clarity('metadata', metadata, false, false, true);
    var capture = native ? Promise.resolve() : new Promise(function (resolve) {
      var timer = setTimeout(resolve, 700);
      waiting.push(function () { clearTimeout(timer); resolve(); });
    });
    return Promise.race([Promise.all([saved, capture]).then(reconcile), new Promise(function (resolve) { setTimeout(resolve, 3500); })]);
  }
  document.addEventListener('visitorConsentCollected', function () { consentKnown = true; reconcile(); });
  window.addEventListener('pageshow', reconcile);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) reconcile(); });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || bypass.has(form)) { if (form) bypass.delete(form); return; }
    var path; try { path = new URL(form.action, location.href).pathname; } catch (_) { return; }
    if (/\/cart\/add\/?$/.test(path)) { reconcile(); return; }
    if (!/\/cart\/?$/.test(path) || !event.submitter || event.submitter.name !== 'checkout') return;
    if (event.defaultPrevented) return;
    event.preventDefault(); var submitter = event.submitter;
    beforeCheckout().finally(function () {
      bypass.add(form); form.requestSubmit(submitter);
    });
  }, true);
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var a = event.target.closest && event.target.closest('a[href]');
    if (!a || a.target === '_blank') return;
    var url; try { url = new URL(a.href, location.href); } catch (_) { return; }
    if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault(); beforeCheckout().finally(function () { location.assign(url.href); });
  }, true);
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err) { consentKnown = true; reconcile(); }
    });
  }
  // Handles the existing consent-gated Clarity loader appearing after this script.
  var attempts = 0, retry = setInterval(function () {
    if (active || ++attempts > 30) clearInterval(retry);
    else if (consent()) reconcile();
  }, 1000);
  status('waiting-consent');
})();
